/**
 * API Service for StockPro
 */
import axios from 'axios';
import apiConfig from '../config/api';

// Create an axios instance with our configuration
const api = axios.create({
  baseURL: apiConfig.baseURL,
  timeout: apiConfig.timeout,
  withCredentials: apiConfig.withCredentials
});

// Response interceptor to handle errors globally
api.interceptors.response.use(
  response => response,
  error => {
    // Handle offline mode
    if (!navigator.onLine) {
      console.log('App is offline. Using cached data if available.');
      // Return a resolved promise to prevent error handling
      return Promise.resolve({
        data: [],
        status: 200,
        statusText: 'OK (Offline)',
        headers: {},
        config: error.config,
        offline: true
      });
    }
    
    // Log API errors
    console.error('API Error:', error.response || error.message);
    
    // Rethrow the error for component-level handling
    return Promise.reject(error);
  }
);

// Request interceptor to add auth token
api.interceptors.request.use(
  config => {
    // Add auth token if available
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

export default api;